import { validateReadingEvidenceConfig } from '../minigames/reading-evidence/ReadingEvidenceConfig.js';

export const AUTHORS_CABIN_PASSAGE = validateReadingEvidenceConfig({
  id: 'authors-cabin-leaf-library-guide',
  skillId: 'literacy.author-purpose.text-features',
  title: 'A Guide to the Leaf Library',
  pages: [
    'HEADING — Keeping Storybooks Safe. The Leaf Library has a wide roof and raised shelves. These parts keep rainwater away from books.',
    'STEPS — First, place dry books upright. Next, leave a small space between them. Last, close the wooden cover before you leave.',
    'CAPTION — A drawing of the sloped roof shows water sliding away from the shelf. A label points to the dry space below it.',
  ],
  question: 'Why did the author write this guide?',
  claimChoices: [
    { id: 'explain-library-care', text: 'To explain how the Leaf Library keeps books safe and how visitors can help.' },
    { id: 'tell-dragon-story', text: 'To tell a make-believe adventure about a dragon who reads.' },
    { id: 'sell-new-books', text: 'To persuade readers to buy a new set of books.' },
  ],
  evidenceDetails: [
    { id: 'ordered-steps', pageIndex: 1, text: 'The guide gives ordered steps for placing and covering books.' },
    { id: 'roof-caption', pageIndex: 2, text: 'The caption explains how the sloped roof moves water away.' },
    { id: 'leaf-name', pageIndex: 0, text: 'The place is named the Leaf Library.' },
    { id: 'drawing-mentioned', pageIndex: 2, text: 'The last page mentions a drawing.' },
  ],
  correctClaimId: 'explain-library-care',
  requiredEvidenceIds: ['ordered-steps', 'roof-caption'],
  hints: [
    'Ask whether the text mainly informs, entertains, or persuades.',
    'Notice the heading, steps, and caption. What do those features help a reader do?',
    'Connect the ordered steps and the roof caption to the author’s purpose.',
  ],
  completionWorldEvent: 'authors-cabin-story-press-powered',
  successMessage: 'Purpose and text features connect. The story press powers on and the cabin path opens!',
});
